<script>
import isEqual from 'lodash/isEqual'
import isObject from 'lodash/isObject'
import ResidualMode from '../../../../Constants/ResidualMode.ts'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import SimpleGroupSelect from '../UI/Form/SimpleGroupSelect.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import AddUserButtonAndModal from '../Entity/AddUserButtonAndModal.vue'
import dynamicFormUtil from '../../Mixins/dynamicFormUtil'
import { COMPUTE_TYPE_AMOUNT } from '../../Constants/ComputeType'
import useForm from '../../../../Composables/useForm.js'
import useProductField from '../../Composables/useProductField'
import { EQUIPMENT_CONDITION_NEW, EQUIPMENT_CONDITION_USED } from '../../Constants/EquipmentCondition'
import RoleEnum from '../../../../Constants/Role'

export default {
  components: { AddUserButtonAndModal, FieldCreator, SimpleGroupSelect, BlockContent, FormCreator },
  mixins: [dynamicFormUtil, mixinComponent, globalVariablesMixin],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      sending: false,
      loading: false,
      loadForm: true,
      loadField: false,
      firstGet: false,
      params: {
        entityById: true,
      },
      platformId: urlParams.get('p'),
      platformParamId: urlParams.get('pp'),
      unitId: urlParams.get('u'),
      platformSalesman: urlParams.get('ps'),
      simulationId: urlParams.get('i'),
      articleId: urlParams.get('a'),
      contractId: urlParams.get('cid'),
      contractNumber: urlParams.get('cn'),
      restructuringId: urlParams.get('restructuringId'),
      type: urlParams.get('t'),
      sirenClient: null,
      sirenClientText: null,
      sirenSupplier: null,
      sirenSupplierText: null,
      reset: urlParams.get('reset'),
      changed: urlParams.get('changed'),
      cancel: urlParams.get('cancel'),
      def: {},
      simulation: {},
      amendmentType: null,
      computeType: null,
      sendingAmount: false,
      sendingRent: false,
      checkinitialRent: false,
      checkleaseback: false,
      displayOpenbar: false,
      residualAsLastRent: false,
      durationNew: [],
      durationOccasion: [],
      contractTypeId: null,
      amountValue: null,
      outstanding: null,
      amountServicesValue: null,
      reversalValue: null,
      residualPercent: null,
      initialRentValue: null,
      initialRentPercent: null,
      residualValue: null,
      vrMax: null,
      vrMin: null,
      validDuration: false,
      articleChoices: [],
      isProcessing: false,
      clientLoading: false,
      supplierLoading: false,
      formData: null,
      queryParameters: new Map([
        ['i', 'simulationId'],
        ['cid', 'contractId'],
        ['cn', 'contractNumber'],
        ['p', 'platformId'],
        ['pp', 'platformParamId'],
        ['u', 'unitId'],
        ['ps', 'platformSalesman'],
        ['s', 'sirenClient'],
        ['sr', 'sirenSupplier'],
        ['t', 'type'],
        ['reset', 'reset'],
        ['changed', 'changed'],
        ['cancel', 'cancel'],
        ['restructuringId', 'restructuringId'],
      ]),
    }
  },
  computed: {
    condition() {
      return this.simulation.equipment.condition
    },
    used() {
      return this.condition === EQUIPMENT_CONDITION_USED
    },
    blockSubmit() {
      return this.clientLoading === true || this.supplierLoading === true
    },
    currentPageUrl() {
      const urlParams = new URLSearchParams({
        index: 'creer',
      })

      for (let [queryParameter, propertyName] of this.queryParameters) {
        let propertyValue = this[propertyName]
        if (['sirenClient', 'sirenSupplier'].includes(propertyName)) {
          propertyValue = this.simulation[propertyName] // sirenClient/sirenSupplier can contain an id so use the simulation property instead
        }

        if (!!propertyValue) {
          urlParams.set(queryParameter, propertyValue)
        }
      }

      return `/devis/simulation.php?` + urlParams.toString()
    },
    platform() {
      if (!!this.platformId) {
        return this.getPlatformById(this.platformId)
      }

      for (let i = 0; i < user.platforms.length; i++) {
        if (user.entity.id === user.platforms[i].id) {
          return user.platforms[i]
        }
      }

      return null
    },
    allowAddOrEditPlatformSalesman() {
      return this.simulation.platform?.enableAddPlatformSalesman ?? false
    },
    isUserOnSinglePlatform() {
      return user.platforms?.length === 1
    },
    isUserOnPlatforms() {
      return user.platforms?.length > 1
    },
    hasPlatformMultipleParams() {
      return this.platform?.platformParams?.length > 1
    },
    isUserOnPlatformsWithParams() {
      return !this.isUserOnSinglePlatform && this.hasPlatformMultipleParams
    },
    productType() {
      if (isObject(this.simulation?.equipment?.productType)) {
        return this.simulation?.equipment?.productType
      }

      if (!this.simulation?.equipment?.productType) {
        return null
      }

      return (
        this.def.equipment.productType.options.choices.find(
          (opt) => opt.id === Number(this.simulation?.equipment?.productType),
        ) ?? null
      )
    },
    residualValueIsPositive() {
      const residualPercent = this.$refs.formsimulation.datas['finance.residualPercent']
      const residualValue = this.$refs.formsimulation.datas['finance.residualValue']
      if (!residualPercent && !residualValue) {
        return false
      }
      return residualPercent > 0 || residualValue > 0
    },
  },
  watch: {
    checkleaseback: {
      deep: true,
      async handler(val) {
        if (!val) {
          this.$refs.formsimulation.object['idSupplier'] = null
          this.def.idSupplier.options.disabled = false

          return
        }

        this.def.idSupplier.options.disabled = true

        const [supplier] = await this.getJSON('entities?id=' + this.sirenClient)

        if (supplier) {
          this.sirenSupplier = supplier.siren ?? this.$refs.formsimulation.object['sirenClient']
          this.sirenSupplierText = [
            supplier.name,
            supplier.siren,
            supplier.address.city,
            supplier.address.postalCode,
          ].join(' - ')

          this.$refs.formsimulation.object['idSupplier'] = supplier.id
          var newOption = new Option(this.sirenSupplierText, supplier.id, true, true)
          $('#idSupplierformsimulation').append(newOption).trigger('change.select2')
        }
      },
    },
    checkinitialRent: {
      deep: true,
      handler(val) {
        if (!val) {
          this.simulation.finance.initialRent = ''
          this.simulation.finance.initialRentPercent = ''
          this.initialRentValue = this.simulation.finance.initialRent
        }
      },
    },
    platformId: {
      handler(val, oldVal) {
        this.firstGet = !oldVal || oldVal == val
      },
    },
    currentPageUrl(url) {
      window.history.pushState({}, '', url)
    },
    params: {
      deep: true,
      async handler(newParams, oldParams) {
        if (isEqual(newParams, oldParams)) {
          return
        }

        await this.$nextTick()
        this.reloadForm()
      },
    },
  },
  methods: {
    disableSubmitClass(computeType = null) {
      return this.blockSubmit || (this.reset && this.computeType == computeType) ? 'disabled' : ''
    },
    removeUrlParams(param) {
      const url = new URL(window.location.href)
      url.searchParams.delete(param)
      window.history.replaceState({}, document.title, url.toString())
    },
    removeProperlyParams(param) {
      const property = this.queryParameters.get(param)

      if (!property) return

      delete this.params[property]
      this[property] = null
      this.removeUrlParams(param)
    },
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.simulation = obj

      this.form.setFormDef(def)
      this.form.setFormData(obj)

      if (!this.platformId) {
        if (this.simulation.platform) {
          this.platformId = this.simulation.platform.id
        }
      }

      this.sirenClient = this.simulation.idClient
      this.sirenSupplier = this.simulation.idSupplier

      const equipmentTypeId = this.simulation.equipment?.equipmentType?.id
      const productTypeId = this.simulation.equipment?.productType?.id

      if (equipmentTypeId) {
        this.setEquipmentType(equipmentTypeId, this.def.equipment.equipmentType.options.choices ?? [])
      }

      if (productTypeId) {
        this.setProductType(productTypeId, this.def.equipment.productType.options.choices ?? [])
      }

      //affiche le montant du premier loyer directement
      if (this.simulation.finance) {
        if (this.simulation.finance.tender) {
          this.def.finance.paymentMean.options.disabled = true
        }
        if (this.simulation.finance.initialRent && parseFloat(this.simulation.finance.initialRent) !== 0) {
          this.checkinitialRent = true
          this.initialRentValue = this.simulation.finance.initialRent
        }
        if (
          this.simulation.finance.initialRentPercent &&
          parseFloat(this.simulation.finance.initialRentPercent) !== 0
        ) {
          this.initialRentPercent = this.simulation.finance.initialRentPercent
        }
        if (this.simulation.finance.residualPercent !== null) {
          this.simulation.finance.residualPercent = parseFloat(this.simulation.finance.residualPercent)
          this.residualPercent = this.simulation.finance.residualPercent
        } else {
          const defaultVR = this.getDefaultVR()
          this.simulation.finance.residualPercent = defaultVR ? parseFloat(defaultVR) : null
        }

        if (this.simulation.finance.residualValue !== null) {
          this.residualValue = parseFloat(this.simulation.finance.residualValue)
        }
        if (this.simulation.finance.amountServices !== null) {
          this.amountServicesValue = this.simulation.finance.amountServices
        }
        if (this.simulation.finance.reversal !== null) {
          this.reversalValue = this.simulation.finance.reversal
        }

        const choices = this.def.finance?.contractType?.options?.choices ?? []
        this.contractTypeId = this.simulation.finance?.contractType?.id ?? (choices.length === 1 ? choices[0].id : null)

        this.resolveContractType()

        //si le computeType est set par défaut et si on reçoit une valeur dans amount ou rent
        if (
          this.simulation.finance.computeType &&
          (this.simulation.finance.simulationAmount || this.simulation.finance.rent)
        ) {
          this.computeType = this.simulation.finance.computeType
        }
        if (this.simulation.finance.residualAsLastRent) {
          this.residualAsLastRent = this.simulation.finance.residualAsLastRent
          this.residualValue = 0
          this.residualPercent = 0
          this.$refs.formsimulation.object.finance.residualValue = null
          this.$refs.formsimulation.object.finance.residualPercent = null
          this.def.finance.residualValue.options.disabled = this.residualAsLastRent
          this.def.finance.residualPercent.options.disabled = this.residualAsLastRent
        }
        const coeffMargin = this.simulation.finance.coeffMargin
        if (coeffMargin) {
          this.displayOpenbar = coeffMargin === 0
        }
        this.$refs.formsimulation.datas['finance.coeffMargin'] = coeffMargin?.id
      }

      if (this.simulation.equipment !== null) {
        this.amountValue = this.$root.getNumber(this.simulation.equipment.amount)
        //set la durée de l'equipement type pour set la duration
        const durationNew = this.simulation.equipment?.equipmentType?.durations
        this.durationNew = durationNew !== '' ? (durationNew?.split(',') ?? []) : []
        const durationOccasion = this.simulation.equipment?.equipmentType?.durationsUsed
        this.durationOccasion = durationOccasion !== '' ? durationOccasion?.split(',') : []

        //affiche l'année en cours lorsque c'est la condition est en occasion
        this.simulation.equipment.year = this.simulation.equipment.year
          ? this.simulation.equipment.year
          : new Date().getFullYear()
      }

      //set les valeurs dans le formCreator
      if (this.simulationId) {
        this.$refs.formsimulation.datas = {
          ...this.$refs.formsimulation.datas,
          simulationId: this.simulationId,
        }
      }
      if (this.contractId) {
        this.$refs.formsimulation.datas = { ...this.$refs.formsimulation.datas, contractId: this.contractId }
      }
      if (this.platformId) {
        this.$refs.formsimulation.datas = { ...this.$refs.formsimulation.datas, platformId: this.platformId }
      }
      if (this.platformParamId) {
        this.$refs.formsimulation.datas = {
          ...this.$refs.formsimulation.datas,
          platformParamId: this.platformParamId,
        }
      }
      if (this.articleId) {
        this.$refs.formsimulation.datas = { ...this.$refs.formsimulation.datas, articleId: this.articleId }
      }
      if (this.cancel) {
        this.$refs.formsimulation.datas = { ...this.$refs.formsimulation.datas, cancel: true }
      }

      if (this.def?.finance?.duration?.options?.choices) {
        this.setDurationChoices()

        if (this.simulation.finance.duration) {
          this.def.finance.duration.options.choices[this.simulation.finance.duration] = this.simulation.finance.duration
        }
      }

      if (
        this.def.equipment &&
        this.def.equipment.year &&
        this.def.equipment.year.options &&
        Object.keys(this.def.equipment.year.options.constraints).length > 0 &&
        this.def.equipment.year.options.choices
      ) {
        let minYear = this.def.equipment.year.options.constraints.min
        for (const [key, value] of Object.entries(this.def.equipment.year.options.choices)) {
          if (value < minYear) {
            delete this.def.equipment.year.options.choices[key]
          }
        }
      }

      this.product = this.simulation.equipment.product ?? null
    },
    setDurationChoices() {
      let duration = {}

      if (this.condition === EQUIPMENT_CONDITION_NEW && this.durationNew.length > 0) {
        if (this.durationNew.length === 1) {
          this.simulation.finance.duration = this.durationNew[0]
        }

        this.durationNew.map((data) => (duration[data] = data))
      } else if (this.condition === EQUIPMENT_CONDITION_USED && this.durationOccasion.length > 0) {
        if (this.durationOccasion.length === 1) {
          this.simulation.finance.duration = this.durationOccasion[0]
        }

        this.durationOccasion.map((data) => (duration[data] = data))
      }

      if (Object.entries(duration).length > 0) {
        this.def.finance.duration.options.choices = duration
      }
    },
    isLoading(bool) {
      this.loading = bool
    },
    isSending(bool) {
      if (this.computeType === 'AMOUNT') {
        this.sendingAmount = bool
      } else {
        this.sendingRent = bool
      }
      this.sending = bool
      this.isProcessing = bool
    },
    setDatas(json) {
      this.$emit('change-index', 'simulation')
      window.history.pushState({}, '', '/devis/simulation.php?i=' + json + '&p=devis&index=simulation')
    },
    setDuration(productType) {
      let obj = {}
      this.vrMax = productType.residualPercentMax
      this.vrMin = productType.residualPercentMin

      let duration = this.condition === EQUIPMENT_CONDITION_NEW ? productType.durations : productType.durationsUsed

      if (duration !== null && duration !== '') {
        duration = duration.split(',')
        duration.map((data) => {
          obj[data] = data
        })

        if (this.def.finance?.duration?.options?.choices) {
          this.def.finance.duration.options.choices = obj
        }
        if (this.simulation.finance?.duration) {
          this.def.finance.duration.options.choices[this.simulation.finance.duration] = this.simulation.finance.duration
        }
      } else {
        if (this.condition === 'NEUF' && this.durationNew.length > 0) {
          this.durationNew.map((data) => {
            obj[data] = data
          })
        } else if (this.condition === EQUIPMENT_CONDITION_USED && this.durationOccasion.length > 0) {
          this.durationOccasion.map((data) => {
            obj[data] = data
          })
        }

        if (this.def.finance?.duration?.options?.choices) {
          this.def.finance.duration.options.choices = obj
        }
        if (this.simulation.finance.duration) {
          durations = Object.values(obj)
          firstDuration = durations[0]
          lastDuration = durations[durations.length - 1]

          if (this.simulation.finance.duration >= firstDuration && this.simulation.finance.duration <= lastDuration) {
            this.validDuration = true
          }

          this.def.finance.duration.options.choices[this.simulation.finance.duration] = this.simulation.finance.duration
          if (this.validDuration) {
            $('#invalid-feedback-finance-duration').html('')
          } else {
            $('#invalid-feedback-finance-duration').html(this.$t('simulation.fields.finance.duration.error'))
          }
        }
      }
    },
    setPercentVR(value) {
      if (value) {
        this.residualPercent = parseFloat(value)
        this.simulation.finance.residualPercent = this.residualPercent
        this.updateResidualPercent(this.residualPercent)
      }
    },
    setResidualAsLastRent(isResidualAsLastRent) {
      this.residualAsLastRent = !isResidualAsLastRent
      this.def.finance.residualValue.options.disabled = !isResidualAsLastRent
      this.def.finance.residualPercent.options.disabled = !isResidualAsLastRent

      if (!isResidualAsLastRent) {
        this.$refs.formsimulation.object.finance.residualValue = null
        this.$refs.formsimulation.object.finance.residualPercent = null
      }
    },
    getPlatformById(id) {
      for (var i = 0; i < user.platforms.length; i++) {
        if (id == user.platforms[i].id) {
          return user.platforms[i]
        }
      }
    },
    async getPlatformSalesman(val) {
      this.platformSalesman = val

      if (this.platformSalesman) {
        this.params = { ...this.params, platformSalesman: this.platformSalesman }
      }

      this.removeProperlyParams('u')

      if (this.def.unit?.options?.choices) {
        this.isLoading(true)
        await this.getJSON(
          `quotationcreate/unit?platformSalesman=${val}&platformId=${this.platformId}&simulationId=${this.simulationId}`,
        ).then((json) => {
          this.def.unit.options.choices = json
          if (json.length > 0) {
            this.handleUnitSelection(json[0].id)
          }

          if (this.simulationId) {
            this.reloadForm()
          } else {
            this.isLoading(false)
          }
        })
      }
    },
    async onClientSelection(val, choices, text) {
      this.clientLoading = true
      await this.handleEntitySelection('idClient', 'sirenClient', val, choices, text)
      this.clientLoading = false
    },
    async handleSupplierSelection(val, choices, text) {
      this.supplierLoading = true
      await this.handleEntitySelection('idSupplier', 'sirenSupplier', val, choices, text)
      this.supplierLoading = false
    },
    async handleEntitySelection(fieldName, propertyName, val, choices, text) {
      if (val === '' || val === null) {
        this[propertyName] = null
        this.$refs.formsimulation.datas[fieldName] = this[propertyName]
        return
      }
      const textPropertyName = propertyName + 'Text'
      if (this.def[fieldName]?.options?.ajax === true) {
        const response = await this.getJSON('entities?q=' + val)

        this[propertyName] = response[0]?.id
        this[textPropertyName] = response[0]?.siren

        this.$refs.formsimulation.def[fieldName].options.choices.push(response[0])
      } else {
        this[propertyName] = val
        this[textPropertyName] = text

        this.$refs.formsimulation.def[fieldName].options.choices.push({ id: val, siren: text })
      }

      await this.$nextTick()

      this.$refs.formsimulation.datas[fieldName] = this[propertyName]
      this.setValue(this.simulation, propertyName, this[textPropertyName])
      if (this[textPropertyName].length > 0) {
        await this.getJSON(
          'entities/refresh?platformParamId=' + this.platformParamId + '&' + fieldName + '=' + this[propertyName],
        )
      }
    },
    getArticleChoice(choices) {
      this.articleChoices = choices
    },
    getArticle(val, choices) {
      if (val) {
        this.articleChoices.map((equipment) => {
          if (equipment.id == val) {
            this.amountValue = equipment.equipmentUnitAmount
            this.simulation.finance.simulationAmount = equipment.equipmentUnitAmount
          }
        })
      }
    },
    setEquipmentType(id, equipmentTypes) {
      this.$refs.formsimulation.object.equipment.equipmentType = id
      equipmentTypes.map((equipmentType) => {
        if (equipmentType.id === parseInt(id)) {
          this.durationNew = equipmentType.durations !== '' ? (equipmentType.durations?.split(',') ?? []) : []
          this.durationOccasion = equipmentType.durationsUsed !== '' ? equipmentType.durationsUsed?.split(',') : []

          this.setDurationChoices()

          this.$refs.formsimulation.object.equipment.productType = null
          /** S'il n'y a qu'un seul type de produit possible, on l'assigne automatiquement */
          if (equipmentType?.productTypes?.length === 1) {
            this.setProductType(equipmentType.productTypes[0].id, [equipmentType.productTypes[0]])
          }
        }
      })
    },
    setProductType(val, choices) {
      this.$refs.formsimulation.object.equipment.productType = val
      choices.map((choice) => {
        if (choice.id === parseInt(val)) {
          this.setDuration(choice)
          this.setPercentVR(choice.residualPercentDefault)
        }
      })
    },
    setContractType(val) {
      this.contractTypeId = val

      if (val == 2) {
        this.$refs.formsimulation.def.finance.residualPercent.options.required = true
        this.$refs.formsimulation.def.finance.residualValue.options.required = true
      }
    },
    setTender(isNotTender) {
      const paymentMeans = this.def.finance.paymentMean.options.choices
      if (!isNotTender) {
        if (paymentMeans.some((paymentMean) => paymentMean.id === 4)) {
          this.def.finance.paymentMean.options.disabled = true
          this.$refs.formsimulation.object.finance.paymentMean = paymentMeans.find(
            (paymentMean) => paymentMean.id === 4,
          )
        }
      } else {
        this.def.finance.paymentMean.options.disabled = false
        this.$refs.formsimulation.object.finance.paymentMean = paymentMeans.find((paymentMean) => paymentMean.id === 1)
      }

      $('#finance-paymentMeanformsimulation')
        .val(this.$refs.formsimulation.object.finance.paymentMean.id)
        .trigger('change')
    },
    getCoeffMargin(val, choices) {
      this.displayOpenbar = val === 0
    },
    getAmount(val) {
      this.amountValue = this.$root.getNumber(val)
      this.getInitialRentPercent(this.initialRentPercent)
      if (!this.residualAsLastRent) {
        if (this.$refs.formsimulation.datas['finance.residualMode'] === ResidualMode.PERCENT) {
          this.residualValue ? this.updateResidualValue(this.residualValue) : null
        } else {
          this.residualPercent ? this.updateResidualPercent(this.residualPercent) : null
        }
      }
      this.reversalValue ? this.getReversal(this.reversalValue) : null
      this.amountServicesValue ? this.getAmountServices(this.amountServicesValue) : null
    },
    getOutstanding(val) {
      this.outstanding = parseInt(val)
    },
    getInitialRent(val, e) {
      this.initialRent = this.$root.getNumber(val)
      if (this.amountValue && val) {
        let amount = this.amountValue
        if (this.outstanding) {
          amount = parseInt(this.amountValue) + parseInt(this.outstanding)
        }
        const percent = this.$root.getRoundFloat((this.initialRent / amount) * 100, 1, 100)
        this.simulation.finance ? (this.simulation.finance.initialRentPercent = percent) : null
        this.initialRentPercent = percent
        this.checkInitialRent(this.initialRent, e)
      }
    },
    getInitialRentPercent(val, e) {
      this.initialRentPercent = this.$root.getNumber(val)
      if (this.amountValue && this.initialRentPercent) {
        let amount = this.amountValue
        if (this.outstanding) {
          amount = parseInt(this.amountValue) + parseInt(this.outstanding)
        }
        const initialRent = this.$root.getRoundFloat(amount, this.initialRentPercent / 100, 100)
        this.simulation.finance ? (this.simulation.finance.initialRent = initialRent) : null
        this.checkInitialRent(initialRent, e)
      }
    },
    setResidualValue(val, e) {
      this.updateResidualMode('AMOUNT')
      this.updateResidualValue(val, e)
    },
    updateResidualValue(val, e) {
      this.residualValue = this.$root.getNumber(val)
      if (this.amountValue && val !== undefined) {
        let amount = this.amountValue
        if (this.outstanding) {
          amount = parseInt(this.amountValue) + parseInt(this.outstanding)
        }
        const percent = this.$root.getRoundFloat((this.residualValue / amount) * 100, 1, 100)
        if (this.simulation.finance) {
          this.simulation.finance.residualPercent = percent
          this.residualPercent = percent
        }
        this.checkInitialResidual(this.residualValue, e)
      }
    },
    updateResidualMode(mode) {
      if (!this.simulation.finance) {
        return
      }
      this.$refs.formsimulation.datas['finance.residualMode'] = mode
    },
    setResidualPercent(val, e) {
      this.updateResidualMode(ResidualMode.PERCENT)
      this.updateResidualPercent(val, e)
    },
    updateResidualPercent(val, e) {
      this.residualPercent = this.$root.getNumber(val)
      if (this.amountValue && val !== undefined) {
        let amount = this.amountValue
        if (this.outstanding) {
          amount = parseInt(this.amountValue) + parseInt(this.outstanding)
        }
        const value = this.$root.getRoundFloat(amount, this.residualPercent / 100, 100)
        if (this.simulation.finance) {
          this.simulation.finance.residualValue = value
          this.residualValue = value
        }
        if (this.def.finance?.residualValue?.options?.display) {
          this.checkInitialResidual(value, e)
        }
      }
    },
    getAmountServices(val) {
      this.amountServicesValue = this.$root.getNumber(val)
      let amount = this.amountValue
      if (this.outstanding) {
        amount = parseInt(this.amountValue) + parseInt(this.outstanding)
      }
      if (this.amountServicesValue > amount) {
        $('#invalid-feedback-finance-amountServices').html(this.$t('simulation.fields.finance.amountServices.error'))
      } else {
        $('#invalid-feedback-finance-amountServices').html('')
      }
    },
    getReversal(val) {
      this.reversalValue = this.$root.getNumber(val)
      let amount = this.amountValue
      if (this.outstanding) {
        amount = parseInt(this.amountValue) + parseInt(this.outstanding)
      }
      if (this.reversalValue > amount * 0.3001) {
        $('#invalid-feedback-finance-reversal').html(this.$t('simulation.fields.finance.reversal.error'))
      } else {
        $('#invalid-feedback-finance-reversal').html('')
      }
    },
    getVrMax() {
      let vrMax = null

      if (this.def.equipment?.productType?.options?.choices) {
        this.def.equipment.productType.options.choices.forEach((productType) => {
          if (productType.id === this.productType?.id) {
            return productType.residualPercentMax
          }
        })
      }

      if (this.def.finance?.residualPercent?.options?.constraints?.max) {
        vrMax = this.def.finance.residualPercent.options.constraints.max
      }

      if (this.vrMax) {
        vrMax = parseFloat(this.vrMax)
      }

      return vrMax ? parseFloat(vrMax) : vrMax
    },
    getVrMin() {
      let vrMin = 0.01

      if (this.def.equipment?.productType?.options?.choices) {
        let residualPercentMin
        this.def.equipment.productType.options.choices.forEach((productType) => {
          if (productType.id === this.productType?.id) {
            residualPercentMin = productType.residualPercentMin
            return
          }
        })

        if (residualPercentMin) {
          return parseFloat(residualPercentMin)
        }
      }

      if (this.def.finance?.residualPercent?.options?.constraints?.min) {
        vrMin = this.def.finance.residualPercent.options.constraints.min
      }

      if (this.vrMin) {
        vrMin = parseFloat(this.vrMin)
      }

      return vrMin
    },
    getDefaultVR() {
      const selectedProductTypeId = this.productType?.id
      if (!selectedProductTypeId) {
        return null
      }

      const productTypes = this.def.equipment?.productType?.options?.choices ?? []
      const selectedProductType = productTypes.find(({ id }) => id === selectedProductTypeId)
      return selectedProductType?.residualPercentDefault
    },
    changePlatform(platformId) {
      if (platformId) {
        this.platformId = platformId
      }
      const platform = this.getPlatformById(platformId)

      if (platform.platformParams.length === 1) {
        this.platformParamId = platform.platformParams[0].id
        this.params = { ...this.params, platformParamId: this.platformParamId }
      }
      if (platform.platformParams.length > 1) {
        let platformParamId = null
        platform.platformParams.forEach((platformParam) => {
          if (platformParam.id === this.simulation?.platformParam?.id) {
            platformParamId = platformParam.id
          }
        })

        this.platformParamId = platformParamId

        this.changePlatformParam(this.platformParamId)

        this.platformId = platform.id
      }
      if (!!this.simulation.sirenClient) {
        this.sirenClient = this.simulation.sirenClient
        this.params = { ...this.params, sirenClient: this.sirenClient }
      }
      if (!!this.simulation.sirenSupplier) {
        this.sirenSupplier = this.simulation.sirenSupplier
        this.params = { ...this.params, sirenSupplier: this.sirenSupplier }
      }
      if (this.simulationId) {
        this.params = { ...this.params, simulationId: this.simulationId }
      }
      if (this.contractId) {
        this.params = { ...this.params, contractId: this.contractId }

        if (this.type == 1) {
          this.amendmentType = 'amendment_additional_equipment'
          this.params = { ...this.params, amendmentType: this.amendmentType }
        }
      }

      if (this.unitId) {
        this.params = { ...this.params, unitId: this.unitId }
      }

      if (this.platformSalesman) {
        this.params = { ...this.params, platformSalesman: this.platformSalesman }
      }

      this.reset = this.reset === 'true'
      if (this.reset) {
        this.changed = this.changed === 'true'
      }
    },
    changePlatformParam(val) {
      this.platformParamId = val
      if (this.platformParamId) {
        this.params = { ...this.params, platformParamId: this.platformParamId }
      } else {
        delete this.params['platformParamId']
      }
    },
    checkInitialRent(initialRent, e) {
      let amount = this.amountValue
      if (this.outstanding) {
        amount = parseInt(this.amountValue) + parseInt(this.outstanding)
      }

      const MAX_INITIAL_RENT_PERCENT = 30
      let maxInitialRentPercent =
        this.$refs.formsimulation?.def?.finance?.initialRentPercent?.options?.constraints?.max ?? 0
      let maxPercent =
        parseInt(maxInitialRentPercent) === 0 ? MAX_INITIAL_RENT_PERCENT : parseInt(maxInitialRentPercent)

      let calculateMaxPercent = maxPercent * 0.01 + 0.0001

      let maxPercentLimitReachMessageError =
        initialRent > amount * calculateMaxPercent
          ? this.$t('simulation.fields.finance.initialRent.error', { data: maxPercent })
          : ''
      $('#invalid-feedback-finance-initialRent').html(maxPercentLimitReachMessageError)
    },
    checkInitialResidual(initialResidual, e) {
      if (this.hasRole(RoleEnum.PRODUCT_TYPE_RESIDUAL_PERCENT_FORCE)) {
        return
      }

      let vrMax = this.getVrMax()
      let vrMin = this.getVrMin()
      let amount = this.amountValue

      if (this.outstanding) {
        amount = parseInt(this.amountValue) + parseInt(this.outstanding)
      }

      const maxThreshold = (amount * vrMax) / 100
      const minThreshold = (amount * vrMin) / 100
      const epsilon = 0.01 // Small tolerance for floating-point precision

      if (initialResidual > maxThreshold && vrMax) {
        $('#invalid-feedback-finance-residualValue').html(
          this.$t('simulation.fields.finance.residualValue.errorSup', { data: vrMax }),
        )
      } else if (initialResidual < minThreshold - epsilon && vrMin) {
        $('#invalid-feedback-finance-residualValue').html(
          this.$t('simulation.fields.finance.residualValue.errorInf', { data: vrMin }),
        )
      } else {
        $('#invalid-feedback-finance-residualValue').html('')
      }
    },
    resolveContractType() {
      const form = this.$refs.formsimulation
      if (!form) return

      if (this.contractTypeId === null) {
        form.object.finance.contractType = null
        return
      }

      form.datas['finance.contractType'] = this.contractTypeId
      form.object.finance.contractType = this.contractTypeId
    },
    postComputeRent(e, amount) {
      if (this.isProcessing) return
      this.resolveContractType()
      Object.assign(this.$refs.formsimulation.datas, { 'finance.computeType': amount })
      Object.assign(this.$refs.formsimulation.datas, { amendmentType: this.amendmentType })
      this.computeType = amount
      if (!this.checkinitialRent) {
        this.$refs.formsimulation.datas['finance.initialRent'] = ''
        this.$refs.formsimulation.datas['finance.initialRentPercent'] = ''
      }
      if (!this.def.finance?.residualPercent?.options?.display) {
        this.$refs.formsimulation.datas['finance.residualPercent'] = null
      }
      if (this.contractTypeId === 2 && !this.residualValueIsPositive) {
        let obj = {
          id: '#invalid-feedback-finance-residualPercent',
          message: 'simulation.fields.contractType.invalidResidualPercent',
        }
        this.$refs.formsimulation.inject['error'] = []
        this.$refs.formsimulation.inject['error'].push(obj)
      } else {
        this.$refs.formsimulation.inject = []
      }
      if (this.$refs.formsimulation.datas['finance.simulationAmount']) {
        $('.invalid-feedback-amount').html('')
        this.$refs.formsimulation.methods()
      } else {
        $('.invalid-feedback-amount').html(this.$t('simulation.fields.finance.amount.error'))
      }
    },
    postComputeAmount(e, rent) {
      if (this.isProcessing) return
      this.resolveContractType()
      Object.assign(this.$refs.formsimulation.datas, { 'finance.computeType': rent })
      Object.assign(this.$refs.formsimulation.datas, { amendmentType: this.amendmentType })
      this.computeType = rent
      if (!this.checkinitialRent) {
        this.$refs.formsimulation.datas['finance.initialRent'] = ''
        this.$refs.formsimulation.datas['finance.initialRentPercent'] = ''
      }
      if (!this.def.finance?.residualPercent?.options?.display) {
        this.$refs.formsimulation.datas['finance.residualPercent'] = null
      }
      if (this.contractTypeId === 2 && !this.residualValueIsPositive) {
        let obj = {
          id: '#invalid-feedback-finance-residualPercent',
          message: 'simulation.fields.contractType.invalidResidualPercent',
        }
        this.$refs.formsimulation.inject['error'] = []
        this.$refs.formsimulation.inject['error'].push(obj)
      } else {
        this.$refs.formsimulation.inject = []
      }
      if (this.$refs.formsimulation.datas['finance.rent']) {
        $('.invalid-feedback-rent').html('')
        this.$refs.formsimulation.methods()
      } else {
        $('.invalid-feedback-rent').html(this.$t('simulation.fields.finance.rent.error'))
      }
    },
    handleUnitSelection(val) {
      this.unitId = val

      if (!!this.unitId) {
        this.params = { ...this.params, unitId: this.unitId }
      } else {
        delete this.params['unitId']
      }
    },
    reloadForm() {
      if (Object.keys(this.params).length > 0) {
        this.loadForm = true

        this.$refs.formsimulation.get()
      } else {
        this.loadForm = false
        this.loadField = false
      }
    },
  },

  watch: {
    checkleaseback: {
      deep: true,
      async handler(val) {
        if (!val) {
          this.$refs.formsimulation.object['idSupplier'] = null
          this.def.idSupplier.options.disabled = false

          return
        }

        this.def.idSupplier.options.disabled = true

        const [supplier] = await this.getJSON('entities?id=' + this.sirenClient)

        if (supplier) {
          this.sirenSupplier = supplier.siren ?? this.$refs.formsimulation.object['sirenClient']
          this.sirenSupplierText = [
            supplier.name,
            supplier.siren,
            supplier.address.city,
            supplier.address.postalCode,
          ].join(' - ')

          this.$refs.formsimulation.object['idSupplier'] = supplier.id
          var newOption = new Option(this.sirenSupplierText, supplier.id, true, true)
          $('#idSupplierformsimulation').append(newOption).trigger('change.select2')
        }
      },
    },
    checkinitialRent: {
      deep: true,
      handler(val) {
        if (!val) {
          this.simulation.finance.initialRent = ''
          this.simulation.finance.initialRentPercent = ''
          this.initialRentValue = this.simulation.finance.initialRent
        }
      },
    },
    platformId: {
      handler(val, oldVal) {
        this.firstGet = !oldVal || oldVal == val
      },
    },
    currentPageUrl(url) {
      window.history.pushState({}, '', url)
    },
    params: {
      deep: true,
      async handler(newParams, oldParams) {
        if (isEqual(newParams, oldParams)) {
          return
        }

        await this.$nextTick()
        this.reloadForm()
      },
    },
    product(value) {
      if (!value) {
        this.form.enableField('idSupplier')
        return
      }

      this.form.setFieldValue('idSupplier', value.supplier.id)
      this.form.addSelectOption('idSupplier', value.supplier)
      this.form.disableField('idSupplier')

      if (this.simulation.finance.computeType === COMPUTE_TYPE_AMOUNT) {
        this.simulation.finance.simulationAmount = value.unitAmount
        this.$refs.formsimulation.datas['finance.simulationAmount'] = value.unitAmount
      }
    },
    'simulation.equipment.condition': {
      handler() {
        if (this.productType) {
          this.setDuration(this.productType)
        }
      },
    },
  },

  setup() {
    const form = useForm()
    const { product } = useProductField({ form, namespace: 'equipment' })

    return {
      form,
      product,
    }
  },

  beforeMount() {
    if (this.platformParamId === null && !!this.platform) {
      if (this.platform.platformParams.length === 1) {
        this.platformParamId = this.platform.platformParams[0].id
      } else {
        this.platformId = this.platform.id
      }
    }

    if (this.simulationId) {
      this.params = { ...this.params, simulationId: this.simulationId }
    }
    if (this.platformParamId) {
      this.params = { ...this.params, platformParamId: Number(this.platformParamId) }
    }
    if (this.contractId) {
      this.params = { ...this.params, contractId: this.contractId }
      if (this.type == 1) {
        this.amendmentType = 'amendment_additional_equipment'
        this.params = { ...this.params, amendmentType: this.amendmentType }
      }
    }
    if (this.articleId) {
      this.params = { ...this.params, articleId: this.articleId }
    }

    if (this.unitId) {
      this.params = { ...this.params, unitId: this.unitId }
    }

    if (this.platformSalesman) {
      this.params = { ...this.params, platformSalesman: this.platformSalesman }
    }

    const urlParams = new URLSearchParams(window.location.search)
    const sirenClient = urlParams.get('s')
    if (sirenClient) {
      this.params = { ...this.params, sirenClient: sirenClient }
    }

    const sirenSupplier = urlParams.get('sr')
    if (sirenSupplier) {
      this.params = { ...this.params, sirenSupplier: sirenSupplier }
    }
    if (this.changed) {
      this.params = { ...this.params, changed: this.changed }
    }

    if (this.restructuringId) {
      Object.assign(this.params, { restructuringId: this.restructuringId })
    }

    if (Object.keys(this.params).length === 0) {
      this.loadForm = false
    }
  },
}
</script>
<template>
  <div>
    <h5 v-if="simulationId" class="font-weight-bold ml-3">
      {{ $t('simulation.title.reset', { id: simulationId }) }}
    </h5>
    <h5 v-if="contractId" class="font-weight-bold ml-3">
      {{ $t('simulation.title.avenant', { id: contractNumber }) }}
    </h5>
    <h5 v-else-if="simulationId == null && contractId == null" class="font-weight-bold ml-3">
      {{ $t('simulation.input.title') }}
    </h5>

    <FormCreator
      v-if="loadForm"
      ref="formsimulation"
      endpoint="quotationcreate"
      method="post"
      :params="params"
      send-params
      class-to-add="d-none"
      src-error="formsimulation"
      @form-build="setBuild"
      @element-build="setElement"
      @form-return="setDatas"
      @is-loading="isLoading"
      @is-sending="isSending"
      @update-data="updateData"
    />

    <BlockContent>
      <div class="container">
        <div class="row">
          <div class="col-md-6" v-if="isUserOnPlatforms">
            <SimpleGroupSelect
              id="platformId"
              add-label
              :label-text="$t('simulation.choice.entity')"
              :model-value="platformId"
              :config-options="user.platforms"
              @transmitted="changePlatform"
            />
          </div>

          <div class="col-md-6" v-if="isUserOnPlatformsWithParams && platformId">
            <SimpleGroupSelect
              add-label
              id="platformParamId"
              :pre-select-value="false"
              :label-text="$t('simulation.choice.setting')"
              :model-value="platformParamId"
              :config-options="platform?.platformParams"
              @transmitted="changePlatformParam"
            />
          </div>

          <div class="col-md-6">
            <FieldCreator
              v-if="loadField"
              :form-data="formData"
              name="platformSalesman"
              form-ref="formsimulation"
              domain="simulation"
              label-top
              dynamic-label
              @get-select-change="getPlatformSalesman"
            >
              <template #add v-if="allowAddOrEditPlatformSalesman">
                <AddUserButtonAndModal
                  class="ml-3"
                  id="add-signer-supplier"
                  user-input-id="#platformSalesmanformsimulation"
                  :client-id="Number(platformId)"
                  :entity-id="Number(platformId)"
                />
              </template>
            </FieldCreator>
          </div>
        </div>

        <template v-if="loading === false && platformId && platformParamId">
          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="companySalesman"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="unit"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
                not-remove
                @get-select-change="handleUnitSelection"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="idClient"
                v-model="sirenClient"
                form-ref="formsimulation"
                domain="simulation"
                value-property="id"
                not-remove
                label-top
                dynamic-label
                add-entity
                edit-entity
                :disabled="clientLoading"
                @get-select-change="onClientSelection"
                type-value="string"
              />
              <div class="invalid-feedback-idClient is-invalid"></div>
            </div>
          </div>

          <div class="row">
            <div
              v-if="(def.idSupplier?.options?.display ?? false) && !isTheme(['ciscar', 'financia'])"
              class="col-md-6 d-flex align-items-center"
              style="padding-bottom: 1em"
            >
              <label for="checkleaseback" style="font-size: 16px">
                <input
                  type="checkbox"
                  id="checkleaseback"
                  name="checkleaseback"
                  v-model="checkleaseback"
                  :checked="simulation.leaseback ? 'checked' : false"
                  e2e-input="checkleaseback"
                />
                &nbsp;{{ $t('simulation.fields.leaseback.label') }}
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="idSupplier"
                form-ref="formsimulation"
                domain="simulation"
                type-value="string"
                value-property="id"
                label-top
                dynamic-label
                not-remove
                add-entity
                :disabled="supplierLoading"
                @get-select-change="handleSupplierSelection"
              />
              <div class="invalid-feedback-idSupplier is-invalid"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.prospect"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                v-if="loadField"
                :form-data="formData"
                name="orderNumber"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.contractType"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="setContractType"
                @get-select-change="setContractType"
              ></FieldCreator>
            </div>
          </div>

          <div class="row" v-if="def?.article?.options.display || def?.equipment?.product?.options.display">
            <div class="col-md-6" v-if="def?.article?.options.display">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="article"
                form-ref="formsimulation"
                domain="simulation"
                :platform-param-id="Number(platformParamId)"
                label-top
                dynamic-label
                @get-autocomplete-result="getArticleChoice"
                @get-select-change="getArticle"
              />
            </div>
            <div class="col-md-6" v-if="form.isFieldDisplayed('equipment.product')">
              <FieldCreator
                v-if="loadField"
                :form-data="formData"
                v-model="product"
                name="equipment.product"
                form-ref="formsimulation"
                domain="simulation"
                label-property="label"
                value-property="id"
                group-property="equipmentType.name"
                label-top
                dynamic-label
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                v-if="loadField"
                :form-data="formData"
                name="equipment.equipmentType"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                select-change="equipment.productType"
                select-change-by-name="productTypes"
                @get-select-change="setEquipmentType"
              />
            </div>
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="equipment.productType"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-select-change="setProductType"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.residualAsLastRent"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
                @get-input-change="setResidualAsLastRent($event)"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.residualPercent"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                type-value="float"
                @get-input-change="setResidualPercent"
                @get-select-change="setResidualPercent"
              ></FieldCreator>
            </div>
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.residualValue"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="setResidualValue"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="equipment.unitAmount"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.outstanding"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="getOutstanding"
              ></FieldCreator>
            </div>
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.commission"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="formerContractNumber"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="frameworkContractNumber"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div
            class="row"
            v-if="
              def.finance
                ? def.finance.rent && def.finance.simulationAmount
                  ? def.finance.rent.options && def.finance.simulationAmount.options
                    ? !def.finance.rent.options.display && def.finance.simulationAmount.options.display
                      ? true
                      : false
                    : false
                  : false
                : false
            "
          >
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.simulationAmount"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="getAmount"
              ></FieldCreator>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-6"
              v-if="
                def.finance
                  ? def.finance.rent && def.finance.simulationAmount
                    ? def.finance.rent.options && def.finance.simulationAmount.options
                      ? def.finance.rent.options.display && !def.finance.simulationAmount.options.display
                        ? true
                        : false
                      : false
                    : false
                  : false
              "
            >
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.rent"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
            <div
              class="col-md-6"
              v-if="
                def.finance
                  ? def.finance.rent && def.finance.simulationAmount
                    ? def.finance.rent.options && def.finance.simulationAmount.options
                      ? !def.finance.rent.options.display && def.finance.simulationAmount.options.display
                        ? true
                        : false
                      : false
                    : false
                  : false
              "
            >
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.amountServices"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="getAmountServices"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div
              class="col-md-3"
              v-if="
                def.finance &&
                def.finance.initialRent &&
                def.finance.initialRentPercent &&
                def.finance.initialRent.options.display &&
                def.finance.initialRentPercent.options.display
              "
            >
              <label v-if="loadField" for="checkinitialRent" style="font-size: 16px">
                <input
                  type="checkbox"
                  id="checkinitialRent"
                  name="checkinitialRent"
                  v-model="checkinitialRent"
                  e2e-input="checkinitialRent"
                />
                {{ $t('simulation.fields.finance.initialRent.label') }}
              </label>
            </div>
            <div class="col-md-3" v-if="checkinitialRent">
              <FieldCreator
                v-if="loadField"
                name="finance.initialRent"
                form-ref="formsimulation"
                :form-data="formData"
                domain="simulation"
                label-top
                dynamic-label
                @get-input-change="getInitialRent"
              />
            </div>
            <div class="col-md-3" v-if="checkinitialRent">
              <FieldCreator
                v-if="loadField"
                name="finance.initialRentPercent"
                form-ref="formsimulation"
                :form-data="formData"
                domain="simulation"
                label-top
                dynamic-label
                @get-input-change="getInitialRentPercent"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.reversal"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-input-change="getReversal"
              ></FieldCreator>
            </div>
          </div>

          <div class="row" v-if="loadField && def?.finance?.guaranteeDeposit?.options.display">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                name="finance.guaranteeDeposit"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <FieldCreator
                v-if="loadField"
                v-model="simulation.equipment.condition"
                :form-data="formData"
                name="equipment.condition"
                form-ref="formsimulation"
                domain="simulation"
                type-value="string"
                label-top
                dynamic-label
              />
            </div>
            <div class="col-md-3" v-if="used">
              <FieldCreator
                v-if="loadField"
                :form-data="formData"
                name="equipment.year"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.contractMode"
                form-ref="formsimulation"
                domain="simulation"
                type-value="string"
                dynamic-label
                label-top
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.duration"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
            <div class="col-md-3">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.period"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.paymentTerm"
                form-ref="formsimulation"
                domain="simulation"
                type-value="string"
                label-top
                dynamic-label
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.tender"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
                @get-input-change="setTender($event)"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.paymentMean"
                form-ref="formsimulation"
                domain="simulation"
                label-top
                dynamic-label
                not-remove
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.nbRentFree"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row" v-if="def?.finance?.coeffMargin?.options?.display">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.coeffMargin"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
                :dynamic-label="true"
                @get-select-change="getCoeffMargin"
              ></FieldCreator>
            </div>
            <div class="col-md-6" v-if="displayOpenbar">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="purchaseRate"
                form-ref="formsimulation"
                domain="simulation"
                :label-top="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.refinancerCategory"
                form-ref="formsimulation"
                domain="simulation"
                :dynamic-label="true"
                :label-top="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.companyCategory"
                form-ref="formsimulation"
                domain="simulation"
                :dynamic-label="true"
                :label-top="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                v-if="loadField"
                name="finance.purchaseCategory"
                form-ref="formsimulation"
                domain="simulation"
                :dynamic-label="true"
                :label-top="true"
              ></FieldCreator>
            </div>
          </div>

          <div class="row" v-if="loadField && simulationId">
            <div class="col-md-6">
              <FieldCreator
                :form-data="formData"
                name="documentCopy"
                v-model="copyDocuments"
                form-ref="formsimulation"
                domain="simulation"
                :label-right="true"
                dynamic-label
              ></FieldCreator>
            </div>
          </div>

          <div class="container mt-5">
            <div
              class="row"
              v-if="
                def.finance &&
                def.finance.rent &&
                def.finance.simulationAmount &&
                def.finance.rent.options &&
                def.finance.simulationAmount.options &&
                def.finance.rent.options.display &&
                def.finance.simulationAmount.options.display
              "
            >
              <div
                v-if="loadField"
                :class="'col-lg-6 col-md-12 mb-20 ' + (def.finance?.rent?.options?.display ? '' : 'offset-3')"
              >
                <div class="card p-30 text-center" style="border: 1px solid #e2e0e0; margin: 0px">
                  <h4 class="text-dark text-uppercase fs-18 font-weight-bold">
                    {{ $t('simulation.calculate.computeAmount') }}
                  </h4>
                  <div style="padding: 30px 0px">
                    <FieldCreator
                      :form-data="formData"
                      name="finance.simulationAmount"
                      form-ref="formsimulation"
                      domain="simulation"
                      @get-input-change="getAmount"
                    ></FieldCreator>
                  </div>
                  <button
                    :class="'btn btn-primary btn-lg onmysubmit ' + disableSubmitClass('RENT')"
                    style="margin: auto; padding: 10px; white-space: unset"
                    @click="postComputeRent($event, 'AMOUNT')"
                    e2e-button="computeRent"
                  >
                    <div v-if="sendingAmount || blockSubmit">
                      <p>
                        <b>{{ $t('simulation.popin.wait.message') }}</b>
                      </p>
                      <div
                        class="progress-bar progress-bar-striped active"
                        role="progressbar"
                        aria-valuenow="90"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%; height: 20px"
                      ></div>
                    </div>
                    <div v-else>{{ $t('simulation.input.button.computeRent') }}</div>
                  </button>
                  <div class="invalid-feedback-amount is-invalid"></div>
                </div>
                <div class="text-center">{{ $t('simulation.calculate.computeRentByAmount') }}</div>
              </div>
              <div
                v-if="loadField"
                :class="
                  'col-lg-6 col-md-12 mb-20 ' + (def.finance?.simulationAmount?.options?.display ? '' : 'offset-3')
                "
              >
                <div class="card p-30 text-center" style="border: 1px solid #e2e0e0; margin: 0px">
                  <h4 class="text-dark text-uppercase fs-18 font-weight-bold">
                    {{ $t('simulation.calculate.computeRent') }}
                  </h4>
                  <div style="padding: 30px 0px">
                    <FieldCreator
                      :form-data="formData"
                      name="finance.rent"
                      form-ref="formsimulation"
                      domain="simulation"
                    ></FieldCreator>
                  </div>
                  <button
                    :class="'btn btn-primary btn-lg onmysubmit ' + disableSubmitClass('AMOUNT')"
                    style="margin: auto; padding: 10px; white-space: unset"
                    @click="postComputeAmount($event, 'RENT')"
                    e2e-button="computeAmount"
                  >
                    <div v-if="sendingRent || blockSubmit" class="text-center">
                      <p>
                        <b>{{ $t('simulation.popin.wait.message') }}</b>
                      </p>
                      <div
                        class="progress-bar progress-bar-striped active"
                        role="progressbar"
                        aria-valuenow="90"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%; height: 20px"
                      ></div>
                    </div>
                    <div v-else>{{ $t('simulation.input.button.computeAmount') }}</div>
                  </button>
                  <div class="invalid-feedback-rent is-invalid"></div>
                </div>
                <div class="text-center">{{ $t('simulation.calculate.computeAmountByRent') }}</div>
              </div>
            </div>
            <div
              v-else-if="loadField && def.finance?.simulationAmount?.options?.display"
              class="d-flex flex-column align-items-center justify-content-center mt-4"
            >
              <button
                class="btn btn-primary btn-lg onmysubmit"
                style="margin: auto; margin-top: 30px; padding: 10px; white-space: unset"
                @click="postComputeRent($event, 'AMOUNT')"
                e2e-button="computeRent"
              >
                <div v-if="sending || blockSubmit" class="text-center">
                  <p>
                    <b>{{ $t('simulation.popin.wait.message') }}</b>
                  </p>
                  <div
                    class="progress-bar progress-bar-striped active"
                    role="progressbar"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 100%; height: 20px"
                  ></div>
                </div>
                <div v-else>{{ $t('simulation.input.button.computeRent') }}</div>
              </button>
              <div class="invalid-feedback-amount is-invalid"></div>
            </div>
            <div
              class="row"
              v-else-if="loadField && def.finance?.rent?.options?.display && !def.finance.rent.options.disabled"
            >
              <button
                class="btn btn-primary btn-lg onmysubmit"
                style="margin: auto; margin-top: 30px; padding: 10px; white-space: unset"
                @click="postComputeAmount($event, 'RENT')"
                e2e-button="computeAmount"
              >
                <div v-if="sending || blockSubmit" class="text-center">
                  <p>
                    <b>{{ $t('simulation.popin.wait.message') }}</b>
                  </p>
                  <div
                    class="progress-bar progress-bar-striped active"
                    role="progressbar"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 100%; height: 20px"
                  ></div>
                </div>
                <div v-else>{{ $t('simulation.input.button.computeAmount') }}</div>
              </button>
              <div class="invalid-feedback-rent is-invalid"></div>
            </div>
          </div>
        </template>
        <template v-else-if="!platformId || !platformParamId" />
        <div v-else class="row justify-content-center">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </BlockContent>
  </div>
</template>
